import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { Text, TextType } from 'ui-components/components/text';

import ModalPortal from '../../../../../components/modal-portal';
import FileUploader from './import-file-uploader';
import { CHOOSE_IMPORT_DIALOGUE, IMPORT_IN_PROGRESS_DIALOGUE } from '../../constants/import-products';
import { importProducts } from '../../../../../store/products/grid/product.grid.actions';

import messages from '../messages';
import style from '../style.module.less';

export const ImportBundlesModal = ({ onClose }) => {
  const dispatch = useDispatch();
  const [file, setFile] = useState(null);
  const [modalDialogue, setModalDialogue] = useState(CHOOSE_IMPORT_DIALOGUE);

  const onConfirm = useCallback(() => {
    const importType = 'Bundles';
    const overwriteExisting = true;
    dispatch(importProducts({ file, importType, overwriteExisting }));
    setModalDialogue(IMPORT_IN_PROGRESS_DIALOGUE);
  }, [dispatch, file]);

  return (
    <ModalPortal onClose={onClose}>
      <Modal size='medium'>
        <ModalHeader>
          <FormattedMessage {...messages.productBundlesImportModalTitle} />
        </ModalHeader>
        <ModalBody className={style['product-import-modal']}>
          {modalDialogue === CHOOSE_IMPORT_DIALOGUE && (
            <>
              <Text
                formattedMessageValues={{ br: <br /> }}
                textType={TextType.Description}
                value={messages.productBundlesImportModalBody}
              />
              <FormattedMessage
                {...messages.productBundlesImportModalBodyList}
                values={{
                  li: (chunks) => <li>{chunks}</li>,
                }}
              />
              <br />
              <a
                href='https://s3.amazonaws.com/downloads.shipstation.com/marketplaces/shipstation/Bundle+Import+Config+Example.csv'
                target='blank'
              >
                <FormattedMessage {...messages.productImportDownloadSampleCSV} />
              </a>
              <h4>
                <FormattedMessage {...messages.productImportSelectFileToImport} />
              </h4>
              <FileUploader file={file} name='productBundlesImport' setFile={setFile} />
            </>
          )}

          {modalDialogue === IMPORT_IN_PROGRESS_DIALOGUE && <FormattedMessage {...messages.productImportModalStarted} />}
        </ModalBody>
        <ModalFooter>
          {modalDialogue === CHOOSE_IMPORT_DIALOGUE && <ModalFooterCancelButton />}
          {modalDialogue === CHOOSE_IMPORT_DIALOGUE && (
            <Button disabled={!file} onClick={onConfirm} theme='primary'>
              <FormattedMessage {...messages.importButton} />
            </Button>
          )}
          {modalDialogue === IMPORT_IN_PROGRESS_DIALOGUE && (
            <Button onClick={onClose} theme='primary'>
              <FormattedMessage {...messages.close} />
            </Button>
          )}
        </ModalFooter>
      </Modal>
    </ModalPortal>
  );
};

ImportBundlesModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
